module.exports = __webpack_public_path__ + "asset/sel--24c977.png";